import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import history from '../../helpers/history';

import { Layout, PageHeader, Checkbox, Button, Typography, Input, Form, Modal, Divider, Spin, message, List, Avatar, Tooltip, Icon, Dropdown, Menu } from 'antd';

import SymbolGroupPage from '../../pannels/stock/SymbolGroupPage';
import USSymbolGroupPage from '../../pannels/stock/USSymbolGroupPage';
import StockOrderPage from '../../pannels/stock/StockOrderPage';
import StockResultPage from '../../pannels/stock/StockResultPage';

import TooltipPage from '../../pannels/account/TooltipPage';
import emitter from '../Evt.js';

import ChatContext from './../ChatProvider';

import './chat.css';

const { Sider, Content } = Layout;

const { TextArea } = Input;
const { Title } = Typography;
const Confirm = Modal.confirm;


var languageMessages = window.appLocale.messages;

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

// 将类别前缀映射到数值  
const categoryMapping = {
    "Fundamental": 0,
    "Historical": 1,
    "Intraday": 2
};

function parseJsonIfPossible(text ) {
    try {
        const jsonObject = JSON.parse(text );
        return {
            isJson: true,
            data: jsonObject
        };
    } catch (e) {

        return jsonMatch(text)

        //return {
        //    isJson: false,
        //    data: text
        //};
    }
}

// 匹配json字符串
function jsonMatch(text) {
    const regex = /```json\s*([\s\S]*?)\s*```/;

    // 使用正则表达式匹配第一个 ```json 标签及其后的内容  
    const match = text.match(regex);

    if (match && match[1]) {
        const jsonString = match[1];
        //console.log("Extracted JSON string:", jsonString);

        // 可选地解析 JSON 字符串为对象
        try {
            const jsonObject = JSON.parse(jsonString);
            //console.log("Parsed JSON object:", jsonObject);

            return {
                isJson: true,
                data: jsonObject
            };
        } catch (error) {
            return {
                isJson: false,
                data: text
            };
        }

    } else {
        return {
            isJson: false,
            data: text
        };
    }
}

class ChatPage extends Component {
    static contextType = ChatContext;

    constructor(props) {
        super(props);

        let tmpStockGroups = window.webType === 'US' ? '10000' : '3180';

        let tmpOrderType = '$VOLUME_NUM';
        let tmpOrderDirection = '0';

        let ideaId = 0;
        if (history.location.state !== undefined) {
            ideaId = history.location.state.ideaId;
        }
        //console.log('ideaId', ideaId);

        this.pageName = 'scanFilter';

        this.user = {};
        this.state = {
            stockPoolKey: 'STOCK',

            lastTimes: 0,

            stockGroups: tmpStockGroups,

            filterId: 0,
            filterName: '',
            filterString: '',

            orderType: tmpOrderType,
            orderDirection: tmpOrderDirection,
            isUseOrder: false,

            modalVisible: false,
            modalTitle: '',
            modelType: '',

            validateStatus: '',
            validateMessage: '',

            stockCount: 0,

            scanAlert: {},

            isShowStockResultPage: false,

            error: '',
            filterError: '',

            scanRequestLoadding: false,
            saveFormulaLoadding: false,
            deleteFormulaLoadding: false,

            stockGroupLoadding: false,
            isStockGroupDone: false,

            // chat
            filterItems: [], //[{ 'FilterId': 'filterId', 'FilterName': 'filterName', 'FilterFormula': 'filterFormula', 'FilterCondition': [{ 'Sentence': 'filterString', 'Category': 'Historical', 'Formula': 'filterFormula' }, { 'Sentence': 'filterString1', 'Category': 'Fundamental', 'Formula': 'filterFormula1' }] }],  // 过滤器列表

            filterConditionItems: [], //[{ 'Id': 1, 'Sentence': 'on 15 minute interval, bollinger band has been widest in the last 10 bars among the previous 100 bars', 'Formula': 'filterFormula', 'Category':'Historical' }], // 公式与自然语言的关联列表
            tmpFilterConditionItems: [],

            newMessage: '',

            ideaId: ideaId,
            ideaName: '',

            renameIdeaId: 0,
            renameIdeaName: '',

            saveButtonStatus: false,

            requestLoadding: false,

            spinLoadding: true
        };

        this.messagesEndRef = React.createRef(); // 创建 ref
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    scrollToBottom = () => {
        if (this.messagesEndRef.current) {
            //this.messagesEndRef.current.scrollTop = this.messagesEndRef.current.scrollHeight;

            //this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
            this.messagesEndRef.current.scrollTop = this.messagesEndRef.current.scrollHeight;
        }
    }

    componentDidMount() {
        emitter.addListener('initPage', this.init);
        emitter.addListener("callSendError", this.callSendError);
        emitter.addListener("callFilterRequestResult", this.callFilterRequestResult);

        emitter.addListener("callScanAlertResult", this.callScanAlertResult);

        emitter.addListener('callCustomSymbolGroups', this.callCustomSymbolGroups);

        emitter.addListener('callSaveFilterRequestResult', this.callSaveFilterRequestResult);

        //this.scrollToBottom();

        this.context.initializeChat(this.pageName);
    }

    componentWillMount() {
        this.init();
    }

    componentWillUnmount() {
        emitter.removeListener('initPage', this.init);
        emitter.removeListener('callSendError', this.callSendError);
        emitter.removeListener('callFilterRequestResult', this.callFilterRequestResult);

        emitter.removeListener('callScanAlertResult', this.callScanAlertResult);

        emitter.removeListener('callCustomSymbolGroups', this.callCustomSymbolGroups);

        emitter.removeListener('callSaveFilterRequestResult', this.callSaveFilterRequestResult);
    }

    callSendError = (status) => {
        var filterError = '';
        switch (status) {
            case 7:
                filterError = languageMessages['today.stock.picks.end'];
                break;
            case 12:
                filterError = languageMessages['Subscription.expired'];
        }

        this.setState({
            spinLoadding: false,
            scanRequestLoadding: false,
            stockGroupLoadding: false,
            isStockGroupDone: false,
            deleteFormulaLoadding: false,
            saveFormulaLoadding: false,
            filterError
        });
    }

    callCustomSymbolGroups = (symbolGroup) => {
        let { isStockGroupDone } = this.state;

        if (symbolGroup.Status === 0) {
            var customStockGroupsCache = JSON.parse(sessionStorage.getItem("CustomStockGroupsCache") || '[]') || [];
            if (customStockGroupsCache.length > 0) {
                const index = customStockGroupsCache.findIndex(item => item.groupId === symbolGroup.gi);
                if (index > -1) {
                    customStockGroupsCache[index].groupName = symbolGroup.gn;
                    customStockGroupsCache[index].symbolList = symbolGroup.sg;
                } else {
                    customStockGroupsCache.push({ groupId: symbolGroup.gi, userId: symbolGroup.ui, groupName: symbolGroup.gn, symbolList: symbolGroup.sg });
                }
            } else {
                customStockGroupsCache.push({ groupId: symbolGroup.gi, userId: symbolGroup.ui, groupName: symbolGroup.gn, symbolList: symbolGroup.sg });
            }
            sessionStorage.setItem("CustomStockGroupsCache", JSON.stringify(customStockGroupsCache));

            isStockGroupDone = true;

            var content = <span>{strReplace(languageMessages['already.add.success'], { '{num}': this.state.stockCount })}，<a href="javascript:;" onClick={this.jumpMyCustomStock}>{languageMessages['view.my.self-selected.stock']}</a></span>;
            this.timerModal(languageMessages['self-selected.stock.added.success'], content);
        } else {
            isStockGroupDone = false;
            message.error(symbolGroup.Description);
        }

        this.setState({ stockGroupLoadding: false, isStockGroupDone });
    }

    // 保存过滤器的返回结果
    callSaveFilterRequestResult = (filterResult, filter, customStrategy) => {
        if (filterResult.Status === 0) {
            if (filter.Category === 'save') {
                var filtersCache = JSON.parse(sessionStorage.getItem("FiltersCache") || '{}') || {};
                filtersCache[filterResult.FilterId] = filterResult.FilterName;
                sessionStorage.setItem("FiltersCache", JSON.stringify(filtersCache));

                let { filterItems } = this.state;

                var conditions = filter.FilterConditionItems;

                conditions.sort((a, b) => {
                    const prefixA = a.Category.split(' ')[0];
                    const prefixB = b.Category.split(' ')[0];
                    return categoryMapping[prefixA] - categoryMapping[prefixB];
                });

                var filterString = '';
                var filterConditionItems = [];
                var idx = 1;
                for (var k in conditions) {

                    filterConditionItems.push({ 'Id': idx, 'IdeaId': filter.IdeaId, 'Sentence': conditions[k].Sentence, 'Formula': conditions[k].Formula, 'Category': conditions[k].Category });

                    var formula = conditions[k].Formula;
                    var tmpString = formula.charAt(formula.length - 1);
                    if (tmpString !== ';') formula += ';';
                    formula += '\n';

                    filterString += formula;

                    idx++;
                }

                var item = { 'IdeaId': filter.IdeaId, 'FilterId': filterResult.FilterId, 'IdeaName': filter.IdeaName, 'FilterName': filterResult.FilterName, 'FilterFormula': filter.FilterString, 'FilterCondition': filterConditionItems };

                const index = filterItems.findIndex(item => item.FilterId === filterResult.FilterId);
                if (index > -1) {
                    filterItems[index] = item;
                } else {
                    filterItems.push(item);
                }
                
                message.success(languageMessages['save.strategy.success']);

                this.setState({
                    filterItems,
                    filterConditionItems,
                    ideaId: filter.IdeaId,
                    ideaName: filter.IdeaName,
                    filterId: filterResult.FilterId,
                    filterName: filterResult.FilterName,
                    filterString,
                    saveFormulaLoadding: false,
                    modalVisible: false,
                    modelType: '',
                    renameIdeaName: ''
                });
            } else {
                message.error(languageMessages['save.strategy.failed']);
                this.setState({
                    saveFormulaLoadding: false
                });
            }
        } else {
            if (filterResult.Description == 'Failed to save filter in database.') {
                var content = <span>{languageMessages['filter.Reached.upper.limit']}，{languageMessages['please go']}<a onClick={this.onValueAddedServices}>{languageMessages['value-added.services']}</a></span>;
                Modal.info({
                    title: languageMessages['prompt'],
                    content: content
                });
                return;
            } else {
                message.error(filterResult.Description);
            }
            
            this.setState({
                saveFormulaLoadding: false
            });
        }
    }

    callFilterRequestResult = (filterResult, filter) => {
        if (filterResult.Status === 0 && filter.Action === 'delete') {

            let { ideaId, ideaName, filterId, filterName, filterItems, filterConditionItems } = this.state;
            
            const index = filterItems.findIndex(item => item.FilterId === filterResult.FilterId);
            // 如果找到该索引，删除该元素  
            if (index > -1) {
                filterItems.splice(index, 1);
            }

            filterConditionItems = filterConditionItems.filter(item => item.IdeaId !== filter.IdeaId);

            // 如果删除的是当前选中的idea，则清理相关变量
            if (ideaId === filter.IdeaId) {
                ideaId = 0;
                ideaName = '';

                filterId = 0;
                filterName = '';
            }
            
            var filtersCache = JSON.parse(sessionStorage.getItem("FiltersCache") || '{}') || {};

            if (filtersCache.hasOwnProperty(filterResult.FilterId)) {
                delete filtersCache[filterResult.FilterId];

                sessionStorage.setItem("FiltersCache", JSON.stringify(filtersCache));
            }

            this.context.disableLastMessageButtons(this.pageName);

            message.success(filterResult.Description);
            this.setState(prevState => ({
                ideaId,
                ideaName,
                filterId,
                filterName,
                filterItems,
                filterConditionItems,
                spinLoadding: false,
            }));
        } else {
            if (filter.Action === 'scan') {
                this.setBotTxtMessage('Re-checking the scan. One moment please.');
            } else {
                message.error(filterResult.Description);
            }
            
            this.setState({
                scanRequestLoadding: false,
                spinLoadding: false,
                //filterError: filterResult.Description,
            });
        }
    }

    callScanAlertResult = (scanAlert, permission, lastTimes) => {

        var message = "Scan completed. Please see results below.";
        if (scanAlert.hasOwnProperty('count') > 0 && scanAlert['count'] > 0) {
            this.user.permission = permission;
            sessionStorage.setItem("auth", JSON.stringify(this.user));

            //message = 'Scan completed. Please see results below.';
            this.setState({
                scanRequestLoadding: false,
                isShowStockResultPage: true,

                saveButtonStatus: true,

                scanAlert,
                lastTimes,

                filterError: '',
            });
        } else {
            //message = 'no data';
            
            this.setState({
                scanRequestLoadding: false,

                saveButtonStatus: true,

                filterError: languageMessages['no.choice.to.stock'],
            });
        }

        this.setBotTxtMessage(message);
    }

    init = () => {
        this.user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
        /**
        if (user.username === undefined) {
            this.setState({ spinLoadding: false }, () => {
                this.props.dispatch({ type: "action_non_user" });
            });
        } else {
            this.props.dispatch({ type: "action_get_luis_sectors", payload: { UserId: user.username, stockPoolKey: this.state.stockPoolKey, stockGroups: this.state.stockGroups } });
        }
        */

        this.setState({ spinLoadding: true }, () => {
            this.props.dispatch({ type: "action_get_chat_sectors", payload: { UserId: this.user.username, stockPoolKey: this.state.stockPoolKey, stockGroups: this.state.stockGroups } });
        });
    }

    setUserPermission(permissions) {
        var lastTimes = 0;
        for (var key in permissions) {
            var permission = permissions[key];
            switch (permission.type) {
                case 'fs':
                    lastTimes += permission.totalCount - permission.usageCount;
                    break;
                case 'bs':
                    lastTimes += permission.totalCount - permission.usageCount;
                    break;
                case 'ps':
                    lastTimes += permission.totalCount - permission.usageCount;
                    break;
                case 'vs':
                    lastTimes += permission.totalCount - permission.usageCount;
                    break;
                case 's1':
                    lastTimes += permission.totalCount - permission.usageCount;
                    break;
                case 's2':
                    lastTimes += permission.totalCount - permission.usageCount;
                    break;
                default:
                    lastTimes += 0;
                    break;
            }
        }
        this.setState({ lastTimes });
    }

    componentWillReceiveProps(props) {
        var { status, state, filterItems, permission, lastTimes, reply, replyIdeaId } = props;

        switch (status) {
            case 'chat_success':
                if (this.state.spinLoadding) {
                    if (this.user.permission !== undefined) {
                        this.user.permission = permission;
                        sessionStorage.setItem("auth", JSON.stringify(this.user));
                        this.setUserPermission(this.user.permission);
                    }

                    var filterId = 0;
                    var ideaName = '';
                    var filterName = '';
                    var filterString = '';
                    var filterConditionItems = [];

                    var buttonMessage = {};

                    var tmpFilterItems = [];
                    if (filterItems !== undefined || filterItems !== null) {
                        for (var i in filterItems) {
                            var tmpFilterCondition = filterItems[i].filterCondition;

                            var tmpFilterConditions = []
                            for (var j in tmpFilterCondition) {
                                tmpFilterConditions.push({
                                    'IdeaId': filterItems[i].ideaId,
                                    'Sentence': tmpFilterCondition[j].sentence,
                                    'Category': tmpFilterCondition[j].category,
                                    'Formula': tmpFilterCondition[j].formula
                                });
                            }

                            tmpFilterItems.push({
                                'IdeaId': filterItems[i].ideaId,
                                'FilterId': filterItems[i].filterId,
                                'IdeaName': filterItems[i].ideaName,
                                'FilterName': filterItems[i].filterName,
                                'FilterFormula': filterItems[i].filterFormula,
                                'FilterCondition': tmpFilterConditions
                            });
                        }

                        var { ideaId } = this.state;
                        var filterItem = tmpFilterItems.filter(function (e) { return e.IdeaId === ideaId });
                        if (filterItem.length > 0) {
                            filterId = filterItem[0].FilterId;
                            ideaName = filterItem[0].IdeaName;
                            filterName = filterItem[0].FilterName;
                            var conditions = filterItem[0].FilterCondition;

                            //console.log('conditions', conditions);

                            conditions.sort((a, b) => {
                                const prefixA = a.Category.split(' ')[0];
                                const prefixB = b.Category.split(' ')[0];
                                return categoryMapping[prefixA] - categoryMapping[prefixB];
                            });
                            
                            var idx = 1;
                            for (var k in conditions) {

                                filterConditionItems.push({ 'Id': idx, 'IdeaId': conditions[k].IdeaId, 'Sentence': conditions[k].Sentence, 'Formula': conditions[k].Formula, 'Category': conditions[k].Category });

                                var formula = conditions[k].Formula;
                                var tmpString = formula.charAt(formula.length - 1);
                                if (tmpString !== ';') formula += ';';
                                formula += '\n';

                                filterString += formula;

                                idx++;
                            }

                            const messages = this.context.getMessages(this.pageName);
                            const lastMessageId = messages.length;
                            const messageId = lastMessageId + 1;

                            buttonMessage = {
                                text: `Do you want to make change to scanner "${ideaName}"?`,
                                sender: 'bot',
                                messageId: messageId,
                                buttons: [
                                    { text: 'Yes', onClick: this.handleYesSelected, clicked: false },
                                    { text: 'No', onClick: this.handleNoSelected, clicked: false }
                                ]
                            };
                            
                        }
                    }

                    //this.setState({ filterItems: tmpFilterItems, spinLoadding: false });

                    this.setState({
                        filterItems: tmpFilterItems,
                        ideaName, filterId, filterName, filterString, filterConditionItems, saveButtonStatus: false, spinLoadding: false
                    }, () => {
                        if (Object.keys(buttonMessage).length > 0) {
                            this.setBotMessage(buttonMessage);
                        }
                    });

                }
                break;
            case 'chat_fail':
                if (this.state.spinLoadding) {
                    if (this.user.permission !== undefined) {
                        this.setUserPermission(this.user.permission);
                    }
                    var error = languageMessages['get.data.failed'];
                    switch (state) {
                        case 0:
                            break;
                        case 2:
                            error = languageMessages['user.exception'];
                            break;
                        default:
                            break;
                    }
                    message.error(error);
                    this.setState({ spinLoadding: false });
                }
                break;
            case 'send_chat_message_success':
                if (this.state.requestLoadding) {
                    var { filterConditionItems, tmpFilterConditionItems, ideaId, filterString, lastTimes } = this.state;
                    
                    let chatMessage = parseJsonIfPossible(reply);
                    
                    ideaId = replyIdeaId === undefined || replyIdeaId == null ? ideaId : replyIdeaId;

                    if (chatMessage['isJson']) {

                        //filterConditionItems: [{ 'filterString': 'on 15 minute interval, bollinger band has been widest in the last 10 bars among the previous 100 bars', 'filterFormula': 'filterFormula' }], 
                        //"Fundamental","Historical","Intraday Price Volume"

                        var conditions = chatMessage['data'].Conditions;

                        // 对 Conditions 列表按照 Category 前缀进行升序排序  
                        conditions.sort((a, b) => {
                            const prefixA = a.Category.split(' ')[0];
                            const prefixB = b.Category.split(' ')[0];
                            return categoryMapping[prefixA] - categoryMapping[prefixB];
                        });

                        //console.log(conditions);

                        filterString = '';

                        filterConditionItems = [];
                        var idx = 1;
                        for (var k in conditions) {

                            filterConditionItems.push({ 'Id': idx, 'IdeaId': ideaId, 'Sentence': conditions[k].Sentence, 'Formula': conditions[k].Formula, 'Category': conditions[k].Category });

                            var formula = conditions[k].Formula;
                            var tmpString = formula.charAt(formula.length - 1);
                            if (tmpString !== ';') formula += ';';
                            formula += '\n';

                            filterString += formula;

                            idx++;
                        }

                        //tmpFilterConditionItems = filterConditionItems;
                    }

                    this.context.setWithoutLastMessageList(this.pageName, - 1);
                    this.setState({ filterConditionItems, tmpFilterConditionItems, ideaId, filterString, requestLoadding: false }, () => {
                        
                        let message = '';
                        if (chatMessage['isJson']) {

                            // 去扫描
                            if (lastTimes <= 0) {
                                var content = <span>{languageMessages['today.stock.picks.end']}，{languageMessages['please go']}<a onClick={this.onValueAddedServices}>{languageMessages['value-added.services']}</a></span>;
                                Modal.info({
                                    title: languageMessages['prompt'],
                                    content: content
                                });
                            } else {
                                window._hmt && window._hmt.push(['_trackEvent', 'Formula scan', 'scan', 'Vernacular Formula scan']);

                                this.checkOperatingStrategy('scan_idea');
                            }

                            message = 'Scanning the market ...';
                        } else {
                            message = this.formatHtml(reply);
                        }

                        this.setBotTxtMessage(message);
                    });
                }
                
                break;
            case 'send_chat_message_fail':

                if (this.state.requestLoadding) {
                    this.context.setWithoutLastMessageList(this.pageName, - 1);
                    this.setState({ requestLoadding: false }, () => {

                        this.setBotTxtMessage('fail');
                    });
                }
                break;
            case 'rename_idea_success':
                if (this.state.saveFormulaLoadding) {
                    //console.log('renameIdeaId', this.state.renameIdeaId);

                    var ideaId = this.state.renameIdeaId;
                    var filterItems = this.state.filterItems.map(item => {
                        if (item.IdeaId === ideaId) {
                            return { ...item, IdeaName: this.state.renameIdeaName };
                        }
                        return item;
                    });

                    message.success('Rename idea successful');

                    this.setState({
                        saveFormulaLoadding: false,
                        modalVisible: false,

                        renameIdeaId: 0,
                        renameIdeaName: '',
                        filterItems,
                        modelType: ''
                    });
                }
                break;
            case 'rename_idea_fail':
                if (this.state.saveFormulaLoadding) {
                    message.error('Rename idea failed');
                    this.setState({
                        saveFormulaLoadding: false
                    });
                }
                break;
            case 'get_stock_count_success':
                this.setState({
                    //stockGroups: data.stockGroups,
                    //stockPoolKey: data.stockPoolKey,
                    error: '',
                    filterError: '',
                });
                break;
            case 'get_stock_count_fail':
                this.setState({
                    error: '',
                    filterError: '',
                });
                break;
            default:
                break;
        }
    }

    timerModal(title, content) {
        let secondsToGo = 5;
        const modal = Modal.success({
            title: title,
            content: content,
        });

        setTimeout(() => {
            modal.destroy();
        }, secondsToGo * 1000);
    }

    jumpMyCustomStock = e => {
        e.preventDefault();

        Modal.destroyAll();

        emitter.emit('callJump', 'customStock');
        history.push("/customStock");
    }

    onValueAddedServices = e => {
        e.preventDefault();
        Modal.destroyAll();

        emitter.emit('callJump', 'service');
        history.push("/sc");
    }

    handleStockOrder(data) {
        this.setState({
            orderType: data.orderType,
            orderDirection: data.orderDirection,
            isUseOrder: data.isUseOrder,
        });
    }

    handleStockGroup(data) {
        this.setState({
            stockGroups: data.stockGroups,
            stockPoolKey: data.stockPoolKey
        }, () => {
            /**
            if (user.username === undefined) {
                this.setState({ spinLoadding: false }, () => {
                    this.props.dispatch({ type: "action_non_user" });
                });
            } else {
                this.props.dispatch({ type: "action_get_stock_count", payload: { UserId: user.username, stockPoolKey: data.stockPoolKey, stockGroups: data.stockGroups } });
            }
            */
            this.props.dispatch({ type: "action_get_stock_count", payload: { UserId: this.user.username, stockPoolKey: data.stockPoolKey, stockGroups: data.stockGroups } });
        });
    }

    handleCustomStock(data) {
        if (this.user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            this.setState({
                stockGroupLoadding: true,
                isStockGroupDone: false,
                stockCount: data.StockCount
            }, () => {

                var action = 'new';
                // 更新股票池
                if (data.GroupId > 0) {
                    action = 'update';
                    //this.props.dispatch({ type: "action_update_formula_custom_stock", payload: { GroupId: data.GroupId, UserId: this.user.username, GroupName: data.GroupName, SymbolList: data.SymbolList } });
                } else {
                    //this.props.dispatch({ type: "action_add_formula_custom_stock", payload: { UserId: this.user.username, GroupName: data.GroupName, SymbolList: data.SymbolList } });
                }

                this.props.dispatch({
                    type: "action_send_hub_message", payload: {
                        service: 'SendCustomSymbolGroups', userId: this.user.username,
                        msg: {
                            Action: action,
                            GroupId: data.GroupId,
                            UserId: this.user.username,
                            GroupName: data.GroupName,
                            OldGroupName: data.GroupName,
                            SymbolList: data.SymbolList
                        }
                    }
                });
            });
        }
    }

    startStockPicker = () => {
        let { filterError, lastTimes } = this.state;

        if (filterError !== '') {
            //message.error(languageMessages['stock.picker.strategy.in.error']);
            //return;
        }

        window._hmt && window._hmt.push(['_trackEvent', 'Formula scan', 'scan', 'Vernacular Formula scan']);

        if (this.user.username === undefined) {
            //saved to cache
            /**
            let tmpScanCondition = {
                filterString: this.state.filterString,
                stockPoolKey: this.state.stockPoolKey,
                stockGroups: this.state.stockGroups,
                orderType: this.state.orderType,
                orderDirection: this.state.orderDirection
            };

            //sessionStorage.setItem("cacheScanCondition", JSON.stringify(tmpScanCondition));
            */
            this.props.dispatch({ type: "action_non_user" });
        } else {
            if (lastTimes <= 0) {
                var content = <span>{languageMessages['today.stock.picks.end']}，{languageMessages['please go']}<a onClick={this.onValueAddedServices}>{languageMessages['value-added.services']}</a></span>;
                Modal.info({
                    title: languageMessages['prompt'],
                    content: content
                });
                return;
            }

            this.checkOperatingStrategy('scan_idea');
        }
    };

    // 保存过滤器，如果是选择的过滤器，只能修改过滤器的内容，不能修改过滤器的名称和ID号
    handleSaveStrategy = () => {
        if (this.user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            let { filterItems, ideaName, renameIdeaId, renameIdeaName } = this.state;

            var isExists = false;
            if (ideaName !== renameIdeaName) {
                var filterItem = filterItems.filter(function (e) { return e.IdeaName.trim().toLowerCase() === renameIdeaName.trim().toLowerCase(); });
                if (filterItem.length > 0) {
                    this.setState({
                        validateStatus: 'error',
                        validateMessage: languageMessages['strategy.name.already.exists'],
                    });

                    isExists = true;
                }
            }

            if (!isExists){

                // 判断是修改ideaName还是保存过滤器
                switch (this.state.modelType) {
                    case "SaveIdea":
                        this.checkOperatingStrategy('save_idea');
                        break;
                    case "RenameIdea":
                        this.setState({ saveFormulaLoadding: true }, () => {
                            this.props.dispatch({
                                type: "action_rename_idea",
                                payload: { UserId: this.user.username, IdeaId: renameIdeaId, IdeaName: renameIdeaName }
                            });
                        });
                        break;
                }
            }
        }
    };

    // 取消保存，如果是选择的过滤器，则过滤器名称不能清空，否则要清空
    handleCancelStrategy = () => {

        this.setState({
            modalTitle: '',
            modalVisible: false,

            validateStatus: '',
            validateMessage: '',

            saveFormulaLoadding: false,

            renameIdeaId: 0,
            renameIdeaName: '',
            modelType: ''
        });
    };

    checkOperatingStrategy(type) {
        var { stockGroups,
            stockPoolKey,
            ideaId,
            ideaName,
            renameIdeaName,
            filterId,
            filterName,
            filterString,
            orderType,
            orderDirection,
            filterConditionItems,
            isUseOrder } = this.state;

        if (stockGroups === '') {
            this.setState({
                error: 'STOCK_GROUP_ERROR',
            });
            return;
        }

        console.log('filterString', filterString);

        if (filterString == '') {
            message.error('The strategy content cannot be empty');
            return;
        }

        if (filterString.length > 8000) {
            message.error(languageMessages['strategy.content.length.too.long']);
            return;
        }
        
        switch (type) {
            case 'scan_idea':
                this.setState({ isShowStockResultPage: false, saveButtonStatus: false, filterError: '', scanRequestLoadding: true }, () => {
                    this.props.dispatch({
                        type: "action_send_hub_message", payload: {
                            service: 'SendFilter', userId: this.user.username,
                            msg: {
                                Category: 'scan',
                                Action: 'scan',
                                UserId: this.user.username,
                                FilterId: 0,
                                FilterName: '',
                                GroupType: stockPoolKey,
                                FilterString: filterString,
                                SymbolGroupId: stockGroups,
                                OrderType: isUseOrder ? '' : orderType,
                                OrderDirection: isUseOrder ? '' : orderDirection
                            }
                        }
                    });
                });
                break;
            case 'save_idea':
                this.setState({ saveFormulaLoadding: true }, () => {
                    this.props.dispatch({
                        type: "action_send_hub_message", payload: {
                            service: 'SendFilter', userId: this.user.username,
                            msg: {
                                Category: 'save',
                                Action: filterId > 0 ? 'update' : 'new',
                                IdeaId: ideaId,
                                IdeaName: renameIdeaName,
                                UserId: this.user.username,
                                FilterId: filterId,
                                FilterName: filterName,
                                GroupType: stockPoolKey,
                                FilterString: filterString,
                                SymbolGroupId: stockGroups,
                                FilterConditionItems: filterConditionItems
                            }
                        }
                    });
                });
                break;
            case "delete_idea":
                this.setState({ spinLoadding: true }, () => {
                    this.props.dispatch({
                        type: "action_send_hub_message", payload: {
                            service: 'SendFilter', userId: this.user.username,
                            msg: {
                                Category: 'delete',
                                Action: 'delete',
                                UserId: this.user.username,
                                IdeaId: ideaId,
                                IdeaName: ideaName,
                                FilterId: filterId,
                                FilterName: filterName,
                                GroupType: stockPoolKey,
                                FilterString: filterString,
                                SymbolGroupId: stockGroups,
                                FilterConditionItems: filterConditionItems
                            }
                        }
                    });
                });
                break;
        }
    }

    onChangeStrategy = e => {
        e.preventDefault();

        var validateStatus = '';
        var validateMessage = '';
        var strategyName = e.target.value;
        if (strategyName !== '') {
            strategyName = strategyName.slice(0, 2000);

            //var pattern = /^[A-Za-z0-9_\u4e00-\u9fa5]+$/gi;
            //if (!pattern.test(strategyName)) {
            //    validateStatus = 'error';
            //    validateMessage = languageMessages['strategy.name.format'];
            //}
        }

        this.setState({
            validateStatus: validateStatus,
            validateMessage: validateMessage,

            renameIdeaName: strategyName
        });
    }

    // 格式化聊天框显示内容
    formatHtml(txt) {
        if (txt === null || txt === undefined || txt === '') return '';

        var txts = [];
        var items = txt.split('\n');
        for (var item in items) {
            if (items[item] != '') {
                const trimmedLine = items[item].trim();
                if (trimmedLine.startsWith('//')) continue;

                if (txts.length > 0) txts.push(<br key={item} />);
                txts.push(trimmedLine);
            }
        }

        return txts;
    }

    setBotMessage = (botResponse) => {
        let i = 0; // Index for botResponse text elements  
        let j = 0; // Index for characters in the current string element  
        let currentText = ''; // Temporary string to hold the current bot message being constructed  

        // Initial setup to ensure there is a placeholder for the bot's current response  
        this.context.addMessage(this.pageName, { text: '', sender: 'bot', messageId: 0, buttons: [], showButtons: false });

        const interval = setInterval(() => {
            let charsToAdd = Math.floor(Math.random() * 20) + 1; // Random number of characters to add in each interval  
            let batchUpdate = false;

            while (charsToAdd > 0) {
                if (i >= botResponse.text.length) {
                    clearInterval(interval); // Clear interval when the response is fully built  

                    // Finalize the message and show buttons if there are any  
                    this.context.addWithoutLastMessageList(this.pageName, {
                        text: currentText,
                        sender: 'bot',
                        messageId: botResponse.messageId,
                        buttons: botResponse.buttons || [],
                        showButtons: !!botResponse.buttons && botResponse.buttons.length > 0
                    }, -1);

                    return; // Exit the function as the response is fully built  
                }

                if (j < botResponse.text[i].length) {
                    const nextChunk = botResponse.text[i].substring(j, j + charsToAdd); // Get the next chunk of characters  
                    currentText += nextChunk; // Append the chunk to current text  
                    j += charsToAdd; // Move the index forward by the number of characters added  
                    charsToAdd -= nextChunk.length;
                    batchUpdate = true;
                } else {
                    i++; // Move to the next element in botResponse  
                    j = 0; // Reset index for new string or element  
                }
            }

            if (batchUpdate) {
                this.context.addWithoutLastMessageList(this.pageName, {
                    text: currentText,
                    sender: 'bot',
                    messageId: 0,
                    buttons: [],
                    showButtons: false
                }, -1);
            }
        }, 5);
    };   

    // 设置聊天框内容
    setBotTxtMessage = (botResponse) => {
        let i = 0; // Index for botResponse elements
        let j = 0; // Index for characters in the current string element
        let currentText = []; // Temporary array to hold the current bot message being constructed
        

        this.context.addMessage(this.pageName, { text: [], sender: 'bot' });

        const interval = setInterval(() => {
            let charsToAdd = Math.floor(Math.random() * 30) + 1;
            let batchUpdate = false;

            while (charsToAdd > 0) {
                if (i >= botResponse.length) {
                    clearInterval(interval); // Clear interval when the response is fully built  
                    break;
                }

                if (typeof botResponse[i] === 'string') {
                    if (j < botResponse[i].length) {
                        const nextChunk = botResponse[i].substring(j, j + charsToAdd); // Get the next chunk of characters
                        currentText.push(nextChunk); // Append the chunk to current text
                        j += charsToAdd; // Move the index forward by the number of characters added
                        charsToAdd -= nextChunk.length;
                        batchUpdate = true;
                    } else {
                        i++; // Move to the next element in botResponse
                        j = 0; // Reset index for new string or element
                    }
                } else if (React.isValidElement(botResponse[i])) {
                    currentText.push(botResponse[i]); // Directly add the React element
                    i++; // Move to the next element
                    batchUpdate = true;
                } else {
                    i++;
                }
            }

            if (batchUpdate) {
                this.context.addWithoutLastMessageList(this.pageName, { text: currentText, sender: 'bot' }, -1);
            }
        }, 5);
    }

    // 聊天框内容变化
    handleMessageChange = e => {
        this.setState({ newMessage: e.target.value });
    };

    // 设置ctrl + enter 提交消息
    handleKeyDown = (event) => {
        if (event.ctrlKey && event.key === 'Enter') {
            event.preventDefault(); // 防止默认行为

            this.handleSendMessage();
        }
    }; 

    // 发送聊天消息
    handleSendMessage = () => {
        if (this.user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            let { newMessage, ideaId, ideaName, filterId, filterName, filterString, filterConditionItems, tmpFilterConditionItems } = this.state;

            const messageQueue = this.context.messageQueue[this.pageName];
            const lastMessageId = messageQueue.messages.length;
            const disabledButtons = messageQueue.disabledButtons || {};
            if (disabledButtons[lastMessageId] === false) {

                //filterConditionItems = tmpFilterConditionItems;

                ideaId = 0;
                ideaName = '';
                filterId = 0;
                filterName = '';

                filterString = '';
                for (var k in filterConditionItems) {

                    var formula = filterConditionItems[k].Formula;
                    var tmpString = formula.charAt(formula.length - 1);
                    if (tmpString !== ';') formula += ';';
                    formula += '\n';

                    filterString += formula;
                }
            }

            let Prompt = newMessage;

            newMessage = this.formatHtml(newMessage);

            this.context.addMessage(this.pageName, { text: newMessage, sender: 'user' });

            var txts = [<Spin key={1} />];

            this.context.addMessage(this.pageName, { text: txts, sender: 'bot' });


            this.setState(prevState => {
                return {
                    newMessage: '',
                    requestLoadding: true,
                    ideaId, ideaName, filterId, filterName, filterString, filterConditionItems
                };
            }, () => {

                // 通知GPT 切换了过滤器  
                this.props.dispatch({
                    type: "action_send_chat_message",
                    payload: { UserId: this.user.username, Prompt, IdeaId: ideaId }
                });
            });
        }
    };

    // 保存过滤器
    handleSaveCondition = () => {
        if (this.user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            //if (this.state.filterId > 0) {
            //    var _this = this;
            //    Confirm({
            //        title: 'Are you sure you want to save this idea?',
            //        content: this.state.ideaName,
            //        okText: languageMessages['yes'],
            //        okType: 'danger',
            //        cancelText: languageMessages['no'],
            //        onOk() {
            //            _this.checkOperatingStrategy('save_idea');
            //        },
            //        onCancel() { },
            //    });
            //} else {
                
            //}

            this.setState({
                modalTitle: 'Save your idea',//languageMessages['new.strategy'],
                modalVisible: true,
                modelType: 'SaveIdea',
                validateStatus: '',
                validateMessage: '',

                renameIdeaName: this.state.ideaName
            });
        }
    };

    handleDeleteFilter = () => {
        if (this.user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            var { ideaName } = this.state;

            var _this = this;
            Confirm({
                title: 'Are you sure you want to delete this idea?',
                content: ideaName,
                okText: languageMessages['yes'],
                okType: 'danger',
                cancelText: languageMessages['no'],
                onOk() {
                    _this.checkOperatingStrategy('delete_idea');
                },
                onCancel() { },
            });
        }
    }

    // 选中复选框
    handleCheckboxChange = (e, id) => {
        e.stopPropagation(); // 防止事件冒泡  

        this.swicthFilterItem(id);
    };

    handleItemClick = (id) => {
        this.swicthFilterItem(id);
    };

    swicthFilterItem(id) {
        let { filterItems, ideaId, ideaName, filterId, filterName, filterString, filterConditionItems, tmpFilterConditionItems } = this.state;


        ideaId = ideaId === id ? 0 : id;
        if (ideaId === 0) {
            //filterConditionItems = tmpFilterConditionItems;

            ideaName = '';
            filterName = '';
            
            filterString = '';
            for (var k in filterConditionItems) {

                var formula = filterConditionItems[k].Formula;
                var tmpString = formula.charAt(formula.length - 1);
                if (tmpString !== ';') formula += ';';
                formula += '\n';

                filterString += formula;
            }

            this.context.disableLastMessageButtons(this.pageName);

            this.setState(prevState => ({
                ideaId, ideaName, filterId, filterName, filterString, filterConditionItems, saveButtonStatus: false
            }));
        } else {
            var filterItem = filterItems.filter(function (e) { return e.IdeaId === ideaId });
            if (filterItem.length > 0) {
                filterId = filterItem[0].FilterId;
                ideaName = filterItem[0].IdeaName;
                filterName = filterItem[0].FilterName;
                var conditions = filterItem[0].FilterCondition;

                //console.log('conditions', conditions);

                conditions.sort((a, b) => {
                    const prefixA = a.Category.split(' ')[0];
                    const prefixB = b.Category.split(' ')[0];
                    return categoryMapping[prefixA] - categoryMapping[prefixB];
                });

                filterConditionItems = [];
                var idx = 1;
                for (var k in conditions) {

                    filterConditionItems.push({ 'Id': idx, 'IdeaId': ideaId, 'Sentence': conditions[k].Sentence, 'Formula': conditions[k].Formula, 'Category': conditions[k].Category });

                    var formula = conditions[k].Formula;
                    var tmpString = formula.charAt(formula.length - 1);
                    if (tmpString !== ';') formula += ';';
                    formula += '\n';

                    filterString += formula;

                    idx++;
                }

                const messageQueue = this.context.messageQueue[this.pageName];
                const lastMessageId = messageQueue.messages.length;
                const messageId = lastMessageId + 1;
                
                const buttonMessage = {
                    text: `Do you want to make change to scanner "${ideaName}"?`,
                    sender: 'bot',
                    messageId: messageId,
                    buttons: [
                        { text: 'Yes', onClick: this.handleYesSelected, clicked: false },
                        { text: 'No', onClick: this.handleNoSelected, clicked: false }
                    ]
                };

                this.setState(prevState => {
                    return {
                        ideaId, ideaName, filterId, filterName, filterString, filterConditionItems, saveButtonStatus: false
                    };
                }, () => {
                
                    this.setBotMessage(buttonMessage);
                });
            } else {
                //filterConditionItems = tmpFilterConditionItems;

                ideaId = 0;
                ideaName = '';
                filterId = 0;
                filterName = '';

                filterString = '';
                for (var k in filterConditionItems) {

                    var formula = filterConditionItems[k].Formula;
                    var tmpString = formula.charAt(formula.length - 1);
                    if (tmpString !== ';') formula += ';';
                    formula += '\n';

                    filterString += formula;
                }

                this.setState({
                    ideaId, ideaName, filterId, filterName, filterString, filterConditionItems, saveButtonStatus: false
                });
            }
        }
    };

    createButton = (index, text, onClick, messageId, clicked) => {
        const disabledButtons = this.context.messageQueue[this.pageName].disabledButtons || {};
        return (
            <Button className={clicked ? 'chat-disabled-button' :''}
                key={Math.random()}
                size='small'
                type="primary"
                onClick={() => onClick(index)}
                disabled={disabledButtons[messageId]}
                style={{ marginLeft: 10 }}
            >
                {text}
            </Button>
        );
    };

    handleYesSelected = (index) => {
        const { ideaId, filterId, filterConditionItems } = this.state;
        const conditions = [];
        let idx = 1;

        for (let i in filterConditionItems) {
            if (filterConditionItems.hasOwnProperty(i)) {
                conditions.push({
                    ID: idx,
                    Sentence: filterConditionItems[i].Sentence,
                    Category: filterConditionItems[i].Category,
                    Formula: filterConditionItems[i].Formula
                });
                idx++;
            }
        }

        const scanner = {
            FilterID: filterId,
            UserID: this.user.username, // 假设这个 UserID 是固定的或来自其他地方  
            Conditions: conditions
        };
        
        var Prompt = JSON.stringify(scanner, null, 2);

        //console.log(Prompt);

        //scanner = {
        //    "FilterID": filterId,
        //    "UserID", this.user.username,
        //    "Conditions":
        //        [{ "ID": 1, "Sentence": "Price gaps 2% higher at open", "Category": "Intraday Price Volume", "Formula": "Open/BarClose('D',-1)-1 >= 0.02;" }, 
        //         { "ID": 2, "Sentence": "Current price is above the daily Bollinger upper band", "Category": "Intraday Price Volume", "Formula": "BarClose('D',0) > BbUpper('D',20,2,-1);" }, 
        //         { "ID": 3, "Sentence": "Current volume is twice the 5-day average volume", "Category": "Historic Price Volume", "Formula": "BarVolume('D',0) >= 2*Sma('VOLUME','D',5,-1);" }
        //        ]
        //}

        var txts = [<Spin key={1} />];

        this.context.addMessage(this.pageName, { text: txts, sender: 'bot' }, index);

        this.setState({ requestLoadding: true }, () => {

            // 通知Model 切换了过滤器
            this.props.dispatch({
                type: "action_send_chat_message",
                payload: { UserId: this.user.username, Prompt, Action: 'ProgramResponse', IdeaId: ideaId }
            });
        });
    };

    handleNoSelected = (index) => {
        let { ideaId, ideaName, filterId, filterName, filterString, filterConditionItems, tmpFilterConditionItems } = this.state;
        

        ideaId = 0;
        ideaName = '';
        filterId = 0;
        filterName = '';

        filterString = '';
        for (var k in filterConditionItems) {

            var formula = filterConditionItems[k].Formula;
            var tmpString = formula.charAt(formula.length - 1);
            if (tmpString !== ';') formula += ';';
            formula += '\n';

            filterString += formula;
        }

        this.context.disableLastMessageButtons(this.pageName, index);

        this.setState(prevState => ({
            ideaId, ideaName, filterId, filterName, filterString, filterConditionItems
        }));
    };

    renderMessageContent = (item) => {
        return (
            <>
                <Typography.Text>{item.text}</Typography.Text>
                {item.showButtons && item.buttons && item.buttons.length > 0 && (
                    <div style={{ marginTop: 10 }}>
                        {item.buttons.map((button, index) => this.createButton(index, button.text, button.onClick, item.messageId, button.clicked))}
                    </div>
                )}
            </>
        ); 

        //if (item.buttons && item.buttons.length > 0) {
        //    return (
        //        <>
        //            <Typography.Text>{item.text}</Typography.Text>
        //            {item.buttons.map((button, index) => this.createButton(button.text, button.onClick, item.messageId))}
        //        </>
        //    );
        //} else {
        //    return <Typography.Text>{item.text}</Typography.Text>;
        //}
    }

    // 删除过滤器 [idea]
    handleDeleteIdea(item) {
        var { stockGroups, stockPoolKey } = this.state;

        if (stockGroups === '') {
            this.setState({
                error: 'STOCK_GROUP_ERROR',
            });
            return;
        }

        var ideaId = item.IdeaId;
        var ideaName = item.IdeaName;
        var filterId = item.FilterId;
        var filterName = item.FilterName;

        var conditions = item.FilterCondition;

        // 对 Conditions 列表按照 Category 前缀进行升序排序  
        conditions.sort((a, b) => {
            const prefixA = a.Category.split(' ')[0];
            const prefixB = b.Category.split(' ')[0];
            return categoryMapping[prefixA] - categoryMapping[prefixB];
        });

        //console.log(conditions);

        var filterString = '';

        var filterConditionItems = [];
        var idx = 1;
        for (var k in conditions) {

            filterConditionItems.push({ 'Id': idx, 'IdeaId': ideaId, 'Sentence': conditions[k].Sentence, 'Formula': conditions[k].Formula, 'Category': conditions[k].Category });

            var formula = conditions[k].Formula;
            var tmpString = formula.charAt(formula.length - 1);
            if (tmpString !== ';') formula += ';';
            formula += '\n';

            filterString += formula;

            idx++;
        }

        console.log('filterString', filterString);

        if (filterString == '') {
            message.error('The strategy content cannot be empty');
            return;
        }

        if (filterString.length > 8000) {
            message.error(languageMessages['strategy.content.length.too.long']);
            return;
        }

        this.setState({ spinLoadding: true }, () => {
            this.props.dispatch({
                type: "action_send_hub_message", payload: {
                    service: 'SendFilter', userId: this.user.username,
                    msg: {
                        Category: 'delete',
                        Action: 'delete',
                        UserId: this.user.username,
                        IdeaId: ideaId,
                        IdeaName: ideaName,
                        FilterId: filterId,
                        FilterName: filterName,
                        GroupType: stockPoolKey,
                        FilterString: filterString,
                        SymbolGroupId: stockGroups,
                        FilterConditionItems: filterConditionItems
                    }
                }
            });
        });
    }

    handleMenuClick = (key, item) => {
        if (this.user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            // 根据 key 处理不同的操作  
            switch (key) {
                case 'rename':
                    // 重命名操作  
                    this.setState({
                        modalTitle: 'Rename your idea',//languageMessages['new.strategy'],
                        modalVisible: true,
                        modelType: 'RenameIdea',
                        validateStatus: '',
                        validateMessage: '',

                        renameIdeaId: item.IdeaId,
                        renameIdeaName: item.IdeaName
                    });
                    break;
                case 'delete':
                    // 删除操作
                    var _this = this;
                    Confirm({
                        title: 'Are you sure you want to delete this idea?',
                        content: item.IdeaName,
                        okText: languageMessages['yes'],
                        okType: 'danger',
                        cancelText: languageMessages['no'],
                        onOk() {
                            _this.handleDeleteIdea(item);
                        },
                        onCancel() { },
                    });
                    break;
                default:
                    break;
            }
        }
    }; 

    renderMenu = (item) => (
        <Menu onClick={(e) => e.domEvent.stopPropagation()}>
            <Menu.Item key="rename">
                <span onClick={() => this.handleMenuClick('rename', item)}>Rename</span>
            </Menu.Item>
            <Menu.Item key="delete">
                <span onClick={() => this.handleMenuClick('delete', item)}>Delete</span>
            </Menu.Item>
        </Menu>
    );

    render() {
        var { stockPoolKey, filterString, stockGroups, newMessage, requestLoadding, ideaId, renameIdeaName, filterItems, filterConditionItems, saveButtonStatus } = this.state;

        var { sectors, stockCount } = this.props;

        var defaultSymbolGroups = {
            stockPoolKey: stockPoolKey,
            stockGroups: stockGroups,
            sectors: sectors,
            stockCount: stockCount,
        }

        let messages = [];
        if (this.user.username !== undefined) {
            messages = this.context.getMessages(this.pageName);
        }

        var formItemLayout = { labelCol: { xs: { span: 24 }, sm: { span: 6 }, }, wrapperCol: { xs: { span: 24 }, sm: { span: 18 }, }, };

        var textareaPlaceholder = 'e.g.';
        textareaPlaceholder += String.fromCharCode(10);
        textareaPlaceholder += 'Daily price making higher high for last 5 days;';
        textareaPlaceholder += String.fromCharCode(10);
        textareaPlaceholder += '30 minute interval, previous close pulled back to 20 period SMA;';

        return (<Content className='main-container total-content'>
            <Helmet>
                <title>{languageMessages['title.newScan']}</title>
                <meta name="keywords" content={languageMessages['vernacular keywords']} />
                <meta name="description" content={languageMessages['description.scan']} />

                <meta property="og:title" content={languageMessages['title.newScan']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['description.scan']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['title.newScan']} />
                <meta name="twitter:description" content={languageMessages['description.scan']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
            <Spin spinning={this.state.spinLoadding}>
                <div className='common-page-header'>
                    <PageHeader title={(<h1>{languageMessages['title.newScan']}</h1>)} />
                    <Modal
                        title={this.state.modalTitle}
                        visible={this.state.modalVisible}
                        onOk={this.handleSaveStrategy}
                        confirmLoading={this.state.saveFormulaLoadding}
                        onCancel={this.handleCancelStrategy}>
                        <Form {...formItemLayout}>
                            <Form.Item label={ 'Brief description'//languageMessages['strategy.name.form']
                            }
                                hasFeedback
                                validateStatus={this.state.validateStatus}
                                help={this.state.validateMessage}>

                                <TextArea
                                    placeholder={'e.g. Daily uptrend, 30 min pullback'}
                                    value={renameIdeaName}
                                    onChange={this.onChangeStrategy}
                                    rows={3}
                                    id={this.state.validateStatus}
                                />
                            </Form.Item>
                        </Form>
                    </Modal>
                </div>
                <Layout style={{ padding: '0px 50px', marginBottom: '20px' }}>

                    {window.webType === 'CN' ? <SymbolGroupPage defaultSymbolGroups={defaultSymbolGroups} stockGroup={this.handleStockGroup.bind(this)} error={this.state.error} /> : <USSymbolGroupPage defaultSymbolGroups={defaultSymbolGroups} stockGroup={this.handleStockGroup.bind(this)} error={this.state.error} />}

                    <div className='common-title'>
                        <Divider type="vertical" />
                        <span>Scanner</span>
                    </div>

                    <Layout className='chat-content'>
                        {/* 过滤器列表 */}
                        <Sider className='chat-column' width={360}>
                            <div className='chat-items'>
                                <div className='chat-title'>
                                    <Title style={{ fontWeight: '600', margin: 0, fontSize: '16px' }}>Ideas</Title>
                                    {
                                    /**
                                     <div>
                                        <Button size='small' type="primary" onClick={this.handleDeleteFilter} disabled={filterId === 0} loading={deleteFormulaLoadding}>
                                            Delete
                                        </Button>
                                    </div>
                                     */
                                    }
                                </div>
                                <div style={{ flex: 1, overflow: 'auto' }}>
                                    <List size={"small"} locale={{ emptyText: ' ' }}
                                        dataSource={filterItems}
                                        renderItem={item => (
                                            <List.Item key={item.IdeaId} onClick={() => this.handleItemClick(item.IdeaId)} className={ideaId == item.IdeaId ? 'checked' : ''}
                                                actions={[
                                                    <Dropdown overlay={() => this.renderMenu(item)} trigger={['click']}>
                                                        <Tooltip title={'Options'}>
                                                            <span onClick={e => e.stopPropagation()} className='large-icon'>
                                                                <Icon type="ellipsis" />
                                                            </span>
                                                        </Tooltip>
                                                    </Dropdown>
                                                ]}
                                            >
                                                {
                                                /**<Checkbox
                                                    checked={ideaId === item.IdeaId}
                                                    onClick={(e) => this.handleCheckboxChange(e, item.IdeaId)}
                                                    >
                                                </Checkbox>*/
                                                }
                                                <Tooltip title={item.IdeaName}>
                                                    <Typography.Text ellipsis>{item.IdeaName}</Typography.Text>
                                                </Tooltip>
                                            </List.Item>
                                        )}
                                        style={{ height: '100%' }}
                                    />
                                </div>
                            </div>
                        </Sider>
                        {/* 过滤器条件列表 */}
                        <Sider className='chat-column' style={{ borderLeft: 'none' }} width={360}>
                            <div className='chat-items'>
                                <div className='chat-title'>
                                    <Title style={{ fontWeight: '600', margin: 0, fontSize: '16px' }}>Condition</Title>
                                    <div>
                                        <Button size='small' type="primary" onClick={this.handleSaveCondition} disabled={filterConditionItems.length === 0 || !saveButtonStatus}>
                                            Save
                                        </Button>
                                    </div>
                                </div>
                                <div style={{ flex: 1, overflow: 'auto' }}>
                                    <List size={"small"} locale={{ emptyText: ' ' }}
                                        dataSource={filterConditionItems}
                                        renderItem={(condition, index) => (
                                            <List.Item>
                                                <Tooltip title={condition.Id + '. ' + condition.Sentence}>
                                                    <Typography.Text ellipsis>{condition.Id + '. ' + condition.Sentence}</Typography.Text>
                                                </Tooltip>
                                            </List.Item>
                                        )}
                                        style={{ height: '100%' }}
                                    />
                                </div>
                            </div>
                        </Sider>
                        {/*聊天界面*/}
                        <Content style={{ border: '1px solid #cdcdcd', marginLeft: '10px' }}>
                            <div className='chat-items'>
                                <div ref={this.messagesEndRef} className="chat-messages">
                                    {messages.length > 0?
                                    (<List
                                        dataSource={messages}
                                        renderItem={item => (
                                            <List.Item className={`message ${item.sender === 'bot' ? 'bot' : 'user'}`}>
                                                {item.sender === 'bot' ? (
                                                    <List.Item.Meta
                                                        avatar={<Avatar src="/static/images/icon-robot.png" />}
                                                        title=""
                                                        description={this.renderMessageContent(item)}
                                                    />
                                                ) : (
                                                        <List.Item.Meta
                                                            title=""
                                                            description={this.renderMessageContent(item)}
                                                            className="user-message"
                                                        />
                                                    )}
                                            </List.Item>
                                        )}
                                        />)
                                        : (<div className='chat-outer-cont'>
                                            <div className='chat-center-left'>What price, volume and technical patterns are you looking for? <br />
                                            Daily and 1, 5, 10, 15, 30, 60 minute intervals are upported.
                                        </div>
                                        </div>)
                                    }
                                </div>
                                <div className="chat-input">
                                    <div className="chat-input-cont">
                                        <TextArea
                                            placeholder={textareaPlaceholder}
                                            value={newMessage}
                                            onChange={this.handleMessageChange}
                                            onKeyDown={this.handleKeyDown}
                                            rows={4}
                                            className="custom-textarea"
                                        />
                                        <Button
                                            type="primary"
                                            loading={requestLoadding}
                                            disabled={requestLoadding || newMessage === ''}
                                            onClick={this.handleSendMessage}
                                            className="custom-send-button"
                                        >
                                            <Icon type="upload" />
                                        </Button>
                                    </div>
                                </div>  

                                {/**
                                 *<div className="chat-input">
                                    <div className="chat-input-cont">
                                        <TextArea
                                            placeholder="Type your message here..."
                                            value={newMessage}
                                            onChange={this.handleMessageChange}
                                            onKeyDown={this.handleKeyDown}
                                            autoSize
                                            style={{ flex: 1, marginRight: '10px' }}
                                        />
                                        <Button type="primary" loading={requestLoadding} disabled={requestLoadding || newMessage === ''} onClick={this.handleSendMessage}>
                                            Send
                                        </Button>
                                    </div>
                                </div>
                                 */ }
                            </div>
                        </Content>
                    </Layout>  

                    <div className="chat-scanner">
                        <StockOrderPage filterString={filterString} isUseOrder={this.state.isUseOrder} stockOrder={this.handleStockOrder.bind(this)} />
                    
                        <Button size='small'
                            onClick={this.startStockPicker}
                            loading={this.state.scanRequestLoadding}
                            disabled={this.state.scanRequestLoadding || this.state.filterString === ''}
                            className='chat-button'>
                            {this.state.scanRequestLoadding ? languageMessages['stock.picking'] : languageMessages['real.stock.picking']}
                        </Button>
                        <TooltipPage lastTimes={this.state.lastTimes} filterError={this.state.filterError} />
                    </div>
                </Layout>
                {this.state.isShowStockResultPage && (<div>
                    <div className='common-separate-block'></div>
                    <Content className='scan-content'>
                        <StockResultPage isStockGroupDone={this.state.isStockGroupDone} stockGroupLoadding={this.state.stockGroupLoadding} stockPoolKey={stockPoolKey} scanAlert={this.state.scanAlert} customStockEvent={this.handleCustomStock.bind(this)} />
                    </Content></div>)}
            </Spin>
        </Content>);
    }
}

function mapStateToProps(state) {
    return state.vernacular;
}

const page = connect(mapStateToProps)(ChatPage);
export { page as default }